import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';

@Component({
  selector: 'app-offices-table',
  templateUrl: './offices-table.component.html',
  styleUrls: ['./offices-table.component.scss'],
})
export class OfficesTableComponent implements OnInit {
  //--------------------Inputs & Outputs--------------------
  @Input() officesFull: any[] | undefined;
  @Input()
  preselectedOffices: number[] = [];
  @Input()
  allSelected: boolean = false;
  @Input() showUsersTable: boolean = false;
  @Output() selectedOfficeEmmited: EventEmitter<any> = new EventEmitter<any>();

  //--------------------Variables--------------------
  oldValue: string = '';
  allSelectedOld: boolean = false;
  switchValue: boolean = false;
  checkedOffices: number[] = [];
  checkbox = { text: '', status: false };
  selectedOffice: any = { name: '' };

  //--------------------Buttons--------------------
  usersButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ver Usuarios',
  };
  kebabButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  ngOnInit(): void {
    this.setOfficesAndPreselected();
  }

  setOfficesAndPreselected() {
    // If there are preselected offices then sets'em
    this.checkedOffices = this.preselectedOffices
      ? this.preselectedOffices
      : [];

    // Sets all the offices state to false
    if (this.officesFull) {
      this.officesFull.forEach((element: { checked: boolean }) => {
        element.checked = false;
      });
    }

    // set only preselected offices to true
    if (this.preselectedOffices) {
      this.preselectedOffices.forEach((preCheckedOffice: number) => {
        if (this.officesFull) {
          const found = this.officesFull.find(
            (officeItem: { id: number }) => officeItem.id == preCheckedOffice
          );
          if (found) found.checked = true;
        }
      });
    }
  }

  //Receives office and state of the checkbox
  checkboxChange(office: any, state: boolean) {
    if (state) {
      this.checkedOffices.push(office.id);
    } else {
      // Looks for the office ID on the checkedOffices array and deletes it
      this.checkedOffices = this.checkedOffices.filter(
        (element) => element != office.id
      );
    }

    this.selectedOfficeEmmited.emit(this.checkedOffices);
  }

  ngOnChanges() {
    //If all Selected has changed
    if (this.allSelected != this.allSelectedOld && this.officesFull) {
      this.officesFull.forEach((officeItem: { id: number; checked: any }) => {
        //Change the state of each office to the one selected (all or none)
        officeItem.checked = this.allSelected;
        if (this.allSelected) {
          this.checkedOffices.push(officeItem.id);
        } else {
          this.checkedOffices = [];
        }
      });
      this.selectedOfficeEmmited.emit(this.checkedOffices);
      this.allSelectedOld = this.allSelected;
    }

    if (this.officesFull) {
      this.officesFull.forEach(
        (officeItem: { checked: boolean; id: number }) => {
          this.checkedOffices.forEach((officeCheckedItem) => {
            if (officeItem.id == officeCheckedItem) {
              officeItem.checked = true;
            }
          });
        }
      );
    }

    this.switchValue = !this.switchValue;
  }
}

//-----------------------------------------------------------------
